import { render } from "./SaleCreation.vue?vue&type=template&id=67dcf8de"
import script from "./SaleCreation.vue?vue&type=script&lang=js"
export * from "./SaleCreation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__